import { getFunc, singlePostFunc, postFunc } from '@/services/index';

export const login = payload => postFunc('auth/login', payload);
export const signup = payload => postFunc('auth/admin/signup', payload);
export const allUsers = page_number => getFunc(`users?page=${page_number}`);

export const allUserStaffs = page_number => getFunc(`users/staff?page=${page_number}`);
export const userDetails = id => getFunc(`user/${id}`);
export const getActivityLogs = page_number => getFunc(`history/activities?page=${page_number}`);
export const updateUser = (user_id, payload) => singlePostFunc(`user/${user_id}`, payload);